module.exports = __webpack_public_path__ + "img/font2.00eb8129.png";